export const Mode = {
  PLAIN: 'plain',
  BLACK: 'black',
  TRANSPARENT: 'transparent',
} as const;

export type Mode = Union<typeof Mode>;
